import L from 'leaflet/dist/leaflet'
import 'leaflet.awesome-markers'

import 'leaflet/dist/leaflet.css'
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css'

document.addEventListener('turbolinks:load', function () {
  function addCircle (shape, map) {
    return L.circle(
      shape.point,
      {
        color: shape.color || '#3388ff',
        opacity: shape.opacity === undefined ? 0.5 : shape.opacity,
        radius: shape.radius,
        fillOpacity: shape.fill_opacity === undefined ? 0.1 : shape.fill_opacity
      }
    ).addTo(map)
  }
  function addMarker (shape, map) {
    var icon = L.AwesomeMarkers.icon({
      icon: shape.icon || 'home',
      iconColor: '000',
      markerColor: shape.color || 'red'
    })
    return L.marker(shape.point, { icon: icon }).addTo(map)
  }
  function setupPopup (leafletShapes, options) {
    var content

    if (options.popup) {
      content = $(options.popup).html()
    } else {
      content = options.label
    }
    if (content) {
      leafletShapes.forEach(function (leafletShape) {
        var popup = leafletShape.bindPopup(content)
        popup.on('popupopen', function (e) {
          popup.setLatLng(leafletShape.getLatLng())
        })
      })
    }
  }

  $('.leaflet-map').each(function (e) {
    var geometry = $(this).data('geometry')
    var zoom = $(this).data('zoom')
    var center = geometry.center

    L.AwesomeMarkers.Icon.prototype.options.prefix = 'fa'
    var map = L.map(this)
    map.setView(center || [0, 0], zoom || 13)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map)
    map.scrollWheelZoom.disable()

    var group = new L.featureGroup()
    geometry.shapes.forEach(function (shape) {
      var leafletShapes

      if (shape.type === 'circle_with_marker') {
        leafletShapes = [addCircle(shape, map), addMarker(shape, map)]
      } else if (shape.type === 'circle') {
        leafletShapes = [addCircle(shape, map)]
      } else if (shape.type === 'marker') {
        leafletShapes = [addMarker(shape, map)]
      }

      setupPopup(leafletShapes, shape)
      leafletShapes.forEach(function (leafletShape) {
        group.addLayer(leafletShape)
      })
    })

    if ((center === undefined || zoom === undefined) && group.getBounds().isValid()) {
      map.fitBounds(group.getBounds())
    }
  })
})
